import sentGAEvent from "@/ga";

/**
 * 上传视频大小导致的购买弹窗展示埋点
 */
const GAPurchaseModalVisibleBySizeLimit = () => {
  sentGAEvent({
    category: "premium_popup",
    action: "premium_popup_20",
  });
};

/**
 * 处理次数导致的购买弹窗展示埋点
 */
const GAPurchaseModalVisibleByTimesLimit = () => {
  sentGAEvent({
    category: "premium_popup",
    action: "premium_popup_6",
  });
};

/**
 * 购买弹窗去注册
 */
const GAPurchaseModalSignUpClick = () => {
  sentGAEvent({
    category: "premium_popup",
    action: "premium_popup_login",
  });
};

/**
 * 购买弹窗去购买
 */
const GAPurchaseModalBuyClick = () => {
  sentGAEvent({
    category: "premium_popup",
    action: "premium_popup_buy",
  });
};

export { GAPurchaseModalVisibleBySizeLimit, GAPurchaseModalVisibleByTimesLimit, GAPurchaseModalSignUpClick, GAPurchaseModalBuyClick };
